import { render, staticRenderFns } from "./ViewResults.vue?vue&type=template&id=cf65aeac&"
import script from "./ViewResults.vue?vue&type=script&lang=js&"
export * from "./ViewResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports